module.exports = __webpack_public_path__ + "img/private-pizzeriano3-nachspeisen.3433ec42.jpg";